import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { LogIn, ArrowRight } from 'lucide-react';

const APP_URL = import.meta.env.VITE_APP_URL || '';

export default function PersonalAreaButton() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isOnLogin = location.pathname === '/login';

  const handleClick = () => {
    if (APP_URL) {
      window.location.href = `${APP_URL}/login`;
    } else {
      navigate(isOnLogin ? '/' : '/login');
    }
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center gap-1.5 px-3.5 py-1.5 rounded-lg bg-cyan-600 text-white text-xs font-semibold hover:bg-cyan-700 transition-colors shadow-sm shadow-cyan-600/20"
    >
      {isOnLogin && !APP_URL ? <ArrowRight className="w-3.5 h-3.5" /> : <LogIn className="w-3.5 h-3.5" />}
      <span className="hidden sm:inline">{t(isOnLogin && !APP_URL ? 'nav.backToSite' : 'nav.personalArea')}</span>
    </button>
  );
}
